<template>
  <div class="con">
    <Nav />
    <div class="newsdetail">
      <div class="newsbody">
        <h2>{{ row.name }}</h2>
        <div class="info">
          <span>{{ row.city }}</span>
          <span>|</span>
          <span>{{ row.category }}</span>
          <span>|</span>
          <span>{{ enumType[row.positionType] }}</span>
        </div>
        <div class="content" v-html="row.detail"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/views/nav";
import dayjs from "dayjs";
import { GetPosition } from "@/api/api";
import positionType from "@/enum/positionType"
export default {
  components: { Nav },
  data() {
    return {
      row: {},
      enumType: positionType
    };
  },
  computed: {
    fmtTime() {
      var t = this.article.createTime;
      if (t) {
        return dayjs(t).format("YYYY年M月D日");
      }
    },
  },
  created() {
    console.log(this.$route.params);
    var { id } = this.$route.params;
    if (id) {
      this.getData(id);
    }
  },
  methods: {
    getData(id) {
      GetPosition(id).then((res) => {
        var { code, data } = res;
        if (code === 0) {
          this.row = data;
        }
      });
    },
  },
};
</script>
<style lang="less">
.newsdetail {
  .newsbody {
    padding: 40px 0;
    padding-bottom: 200px;
    width: 840px;
    margin: 0 auto;

    h2 {
      font-weight: 500;
      font-size: 30px;
      color: #242a32;
    }

    .info {
      margin: 20px 0 40px 0;
      span {
        margin-right: 10px;
        font-size: 16px;
        color: #5e656c;
      }
    }

    .content {
      p {
        font-size: 14px;
        line-height: 28px;
        color: #242a32;
        margin-bottom: 30px;
      }
      img {
        display: block;
        max-width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/join/detail.vue